<template>
  <b-container>
    <div class="messages-page page w-100 p-0 m-0">
      <div class="page__header">
        <h2>My Messages</h2>
      </div>
    </div>
  </b-container>
</template>
<script>
/**
 * ==================================================================================
 * Messages page
 * ==================================================================================
 **/

export default {
  metaInfo: function() {
    return {
      title: 'My messages'
    }
  }
}
</script>
